import { savePushTokenForDevice } from './savePushTokenForDevice';

export const clearPushTokenForDevice = async (userId: string, device: string) =>
  savePushTokenForDevice(userId, '', device);
